import { render, staticRenderFns } from "./InsertTokenActions.partial.vue?vue&type=template&id=b8385222&scoped=true"
import script from "./InsertTokenActions.partial.vue?vue&type=script&lang=js"
export * from "./InsertTokenActions.partial.vue?vue&type=script&lang=js"
import style0 from "./InsertTokenActions.partial.vue?vue&type=style&index=0&id=b8385222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8385222",
  null
  
)

export default component.exports